// reset.view — layar Reset Data (Owner). Sengaja dibuat "sulit dipakai buru-buru": setiap pagar
// tampil sebagai langkah tersendiri supaya orang membaca dulu apa yang akan hilang.
import { esc } from '@domain/format';
import { currentUser } from '@core/session';
import { listCabang } from '@modules/cabang/cabang.repo';
import * as svc from './reset.service';

export async function renderResetData(root: HTMLElement): Promise<void> {
  if (currentUser()?.role !== 'Owner') {
    root.innerHTML = `<div class="panel err">Hanya Owner yang boleh membuka Reset Data.</div>`;
    return;
  }
  let cabang: { kode: string; nama: string }[] = [];
  try { cabang = await listCabang(); } catch { /* daftar cabang opsional */ }

  root.innerHTML = `<div class="ttl">⚠️ Reset Data</div>
    <div class="scope-note" style="background:var(--dangerbg);color:var(--danger)">
      <b>Menghapus data usaha secara permanen.</b> Sebelum menghapus, sistem menjalankan <b>backup otomatis</b> —
      bila backup gagal, reset dibatalkan. Riwayat reset tetap tercatat di Audit Log.</div>

    <div class="panel" style="max-width:560px">
      <div class="field"><label>Lingkup</label>
        <label style="display:flex;gap:8px;align-items:flex-start;margin:6px 0"><input type="radio" name="rs_scope" value="CABANG" checked>
          <span><b>Satu cabang</b><br><span style="color:var(--muted);font-size:12px">Transaksi, pelanggan, kas, beban, absensi, karyawan, dan cabang itu sendiri dihapus. Cabang lain tak tersentuh.</span></span></label>
        <label style="display:flex;gap:8px;align-items:flex-start;margin:6px 0"><input type="radio" name="rs_scope" value="SEMUA">
          <span><b>Semua data</b><br><span style="color:var(--muted);font-size:12px">Seluruh cabang, karyawan (termasuk akun login &amp; portal supplier), dan transaksi dihapus. Hanya akun <b>Owner</b> dan setelan toko yang tersisa — cabang dibuat ulang dari nol.</span></span></label></div>

      <div class="field" id="rs_cabWrap"><label>Cabang yang direset</label>
        <select id="rs_cab">${cabang.map((o) => `<option value="${esc(o.kode)}">${esc(o.nama)} (${esc(o.kode)})</option>`).join('') || '<option value="">— belum ada cabang —</option>'}</select></div>

      <div class="field"><label>Alasan <span class="req">*</span></label><input id="rs_alasan" placeholder="mis. data uji coba sebelum mulai pakai"></div>

      <div class="field"><label>1️⃣ Password Anda <span class="req">*</span></label><input id="rs_pass" type="password" autocomplete="current-password"></div>

      <div class="field"><label>2️⃣ Kode dari aplikasi authenticator <span class="req">*</span></label>
        <input id="rs_kode" inputmode="numeric" maxlength="6" placeholder="6 angka dari Google Authenticator">
        <div class="scope-note" style="font-size:11.5px" id="rs_2faNote">Membuktikan yang menekan tombol memang pemegang alat kedua, bukan orang yang kebetulan menemukan layar terbuka.</div></div>

      <div class="field"><label>3️⃣ Ketik frasa konfirmasi <span class="req">*</span></label>
        <input id="rs_frasa" placeholder="—" autocapitalize="characters">
        <div class="scope-note" style="font-size:11.5px">Ketik persis: <b id="rs_frasaTxt">—</b></div></div>

      <div class="err" id="rs_err"></div>
      <button class="btn" id="rs_go" style="background:var(--danger);color:#fff;border-color:var(--danger);margin-top:6px">🗑️ Backup & Reset Sekarang</button>
    </div>`;

  const $ = <T extends HTMLElement>(id: string): T => root.querySelector<T>('#' + id)!;
  const err = $('rs_err');
  const lingkup = (): svc.LingkupReset => (root.querySelector<HTMLInputElement>('input[name="rs_scope"]:checked')!.value as svc.LingkupReset);
  const outlet = (): string => $<HTMLSelectElement>('rs_cab').value;
  const segarkanFrasa = (): void => {
    const perCabang = lingkup() === 'CABANG';
    $('rs_cabWrap').style.display = perCabang ? '' : 'none';
    $('rs_frasaTxt').textContent = svc.frasaKonfirmasi(lingkup(), outlet());
  };
  root.querySelectorAll('input[name="rs_scope"]').forEach((r) => r.addEventListener('change', segarkanFrasa));
  $('rs_cab').addEventListener('change', segarkanFrasa);
  segarkanFrasa();

  // 2FA wajib — beri tahu di muka, jangan biarkan Owner mengisi semuanya lalu ditolak di ujung.
  void svc.siap2FA().then((ok) => {
    if (ok) return;
    $('rs_2faNote').innerHTML = '⚠️ <b>2FA belum aktif.</b> Aktifkan dulu lewat tombol 🔑 di atas (Keamanan Akun) — Reset Data mewajibkannya.';
    $('rs_2faNote').style.color = 'var(--danger)';
    $<HTMLButtonElement>('rs_go').disabled = true;
  });

  $('rs_go').addEventListener('click', () => void (async () => {
    const b = $<HTMLButtonElement>('rs_go'); err.textContent = '';
    if (!confirm(`Terakhir kali: ${lingkup() === 'SEMUA' ? 'SELURUH data usaha' : 'data cabang ' + outlet()} akan dihapus permanen. Lanjut?`)) return;
    b.disabled = true; b.textContent = 'Backup & menghapus…';
    try {
      const h = await svc.resetData({
        lingkup: lingkup(), outlet: outlet(), alasan: $<HTMLInputElement>('rs_alasan').value,
        password: $<HTMLInputElement>('rs_pass').value, kode2FA: $<HTMLInputElement>('rs_kode').value,
        frasa: $<HTMLInputElement>('rs_frasa').value,
      });
      alert(`Reset selesai (${h.scope}${h.outlet ? ' · ' + h.outlet : ''}). ${h.karyawan_dihapus} akun karyawan dihapus.\nHalaman akan dimuat ulang.`);
      window.location.reload();
    } catch (e) {
      err.textContent = (e as Error).message;
      b.disabled = false; b.textContent = '🗑️ Backup & Reset Sekarang';
    }
  })());
}
